import { createReducer } from '@reduxjs/toolkit';
import { State, RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import {
  createSituation,
  createdSituation,
  updateSituation,
  updatedSituation,
  deleteSituation,
  deletedSituation,
} from './actions';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  errorType: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(createSituation, (state) => {
      state.status = 'loading';
    })
    .addCase(createdSituation, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(updateSituation, (state) => {
      state.status = 'loading';
    })
    .addCase(updatedSituation, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(deleteSituation, (state) => {
      state.status = 'loading';
    })
    .addCase(deletedSituation, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
        state.errorType = 'delete';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'Situation') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
